import { render, staticRenderFns } from "./NoticeViewDialog.vue?vue&type=template&id=743d4c6d&"
import script from "./NoticeViewDialog.vue?vue&type=script&lang=js&"
export * from "./NoticeViewDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports